import React, { useRef } from "react";
import { TextFieldComponent } from "@/components/basic/TextField";
import { RegisterUserPasswordField } from "@/components/RegisterUserPasswordField/RegisterUserPasswordField";
import { SelectComponent } from "@/components/basic/Select";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import {
  checkEmailIsRegistered,
  selectIsAuthenticate,
} from "@/core/store/authSlice";

type Props = {
  values: {
    email: string;
    title: string;
    telephone1: string;
    forename: string;
    surname: string;
    [key: string]: string | boolean | undefined;
  };
  touched: {
    [key: string]: boolean | undefined;
  };
  errors: {
    [key: string]: string | undefined;
  };
  handleChange: (e: React.FormEvent<any>) => void;
  setFieldValue: Function;
  handleBlur: (e: React.FocusEvent<any, Element>) => void;
};

export const PurchaserDetails = React.memo(
  ({
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    setFieldValue,
  }: Props) => {
    const dispatch = useAppDispatch();
    const lastEmail = useRef(values.email);
    const isAuthenticate = useAppSelector(selectIsAuthenticate);

    return (
      <>
        <TextFieldComponent
          className="w-full"
          label="Email"
          placeholder="Your email address"
          disabled={isAuthenticate}
          onChange={handleChange}
          onBlur={(e) => {
            handleBlur(e);
            if (lastEmail.current !== e.target.value && !errors.email) {
              lastEmail.current = e.target.value;
              dispatch(checkEmailIsRegistered(e.target.value));
            }
          }}
          name="email"
          value={values.email}
          errorMsg={touched.email ? errors.email : ""}
        ></TextFieldComponent>
        <RegisterUserPasswordField
          email={errors.email ? "" : values.email}
        ></RegisterUserPasswordField>
        <TextFieldComponent
          className="w-full"
          label="Phone number"
          placeholder="Your phone number"
          name="telephone1"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.telephone1}
          errorMsg={touched.telephone1 ? errors.telephone1 : ""}
        ></TextFieldComponent>
        <div className="grid grid-cols-5 gap-4">
          <SelectComponent
            label="Title"
            options={["Mr", "Miss", "Mrs", "Ms"]}
            onChange={(e) => {
              const target = e.target as typeof e.target & {
                value: string;
              };
              setFieldValue("title", target.value);
            }}
            wrapperClassName="lg:col-span-1 col-span-full"
            name="title"
            defaultValue={values.title}
            errorMsg={touched.title ? errors.title : ""}
          ></SelectComponent>

          <TextFieldComponent
            name="forename"
            wrapperClassName="lg:col-span-2 col-span-full"
            className="w-full "
            label="First name"
            placeholder="First name"
            onChange={handleChange}
            value={values.forename}
            errorMsg={touched.forename ? errors.forename : ""}
          ></TextFieldComponent>
          <TextFieldComponent
            name="surname"
            wrapperClassName="lg:col-span-2 col-span-full"
            className="w-full"
            label="Surname"
            placeholder="Surname"
            onChange={handleChange}
            value={values.surname}
            errorMsg={touched.surname ? errors.surname : ""}
          ></TextFieldComponent>
        </div>
      </>
    );
  }
);
